import { io } from 'socket.io-client';
import { jwtDecode } from 'jwt-decode';


let socket = null;

//Helper function to establish socket connection
export const createSocketConnection = (url, token, onContainerDisconnect) => {

    // Clean up existing socket if it exists
    if (socket) {
        socket.removeAllListeners();
        socket.close();
        socket = null;
    }

    if (!token) {
        console.error('No authentication token found');
        return null;
    }

    const { userId } = jwtDecode(token);

    // Track connection attempts
    let connectionAttempts = 0;
    const MAX_RETRY_ATTEMPTS = 3;

    socket = io(url, {
        auth: {
            user_id: userId,
            type: 'client'
        },
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        timeout: 20000,
    });

    // Connection event handlers
    socket.on('connect', () => {
        connectionAttempts = 0;
    });

    socket.on('connect_error', (error) => {
        connectionAttempts++;
        console.error(`Socket connection error (Attempt ${connectionAttempts}):`, error);

        // Calculate exponential backoff delay
        const nextDelay = Math.min(1000 * Math.pow(2, connectionAttempts), 10000);
        socket.io.opts.reconnectionDelay = nextDelay;

        // If max retry attempts reached, call disconnection handler
        if (connectionAttempts >= MAX_RETRY_ATTEMPTS) {
            console.error('Max connection attempts reached');

            // Disconnect the socket
            socket.disconnect();

            // Call the container disconnection handler
            onContainerDisconnect();
        }
    });

    socket.on('disconnect', (reason) => {
        if (reason === 'io server disconnect') {
            setTimeout(() => socket.connect(), 1000);
        }
        onContainerDisconnect();
    });

    socket.on('container:disconnected', () => {
        onContainerDisconnect();
        socket.disconnect();
    });

    socket.on('container:unavailable', () => {
        onContainerDisconnect();
        socket.disconnect();
    });

    socket.on('error', (error) => {
        console.error('Socket error:', error);
    });

    return socket;
};

// Helper function to cleanup socket connection
export const cleanupSocket = () => {
    if (socket) {
        socket.removeAllListeners();
        socket.close();
        socket = null;
    }
};

// Helper function to check if socket is connected
export const isSocketConnected = (socketInstance) => {
    return socketInstance?.connected || false;
};
